// Presets de período do cabeçalho da visão geral (canvas: `Segmented` com Hoje · 7 dias ·
// 30 dias · Personalizado). Porta só o pedaço de `kit/date-range-filter.tsx`
// que esta tela usa; o popover de calendário do kit fica de fora (banido nesta tela, ver
// "Questões abertas" da task: `period-control.tsx` usa dois `<input type="date">` nativos).

import { addDaysToIsoDate, todayIsoDate } from '../../lib/dates.ts';

export type DatePreset = 'today' | '7d' | '30d' | 'custom';

export interface DateRangeValue {
  preset: DatePreset;
  /** `YYYY-MM-DD` em `America/Sao_Paulo`. */
  from: string;
  to: string;
}

/** Mesma ordem e rótulos do croqui (`components/Shell` usa `Segmented` com este par). */
export const PERIOD_OPTIONS: readonly (readonly [DatePreset, string])[] = [
  ['today', 'Hoje'],
  ['7d', '7 dias'],
  ['30d', '30 dias'],
  ['custom', 'Personalizado'],
];

export function rangeForPreset(preset: DatePreset, today = todayIsoDate()): DateRangeValue {
  const days = preset === 'today' ? 0 : preset === '7d' ? 6 : 29;
  return { preset, from: addDaysToIsoDate(today, -days), to: today };
}
